import agentApi from "../apis/agentApi";

import { FETCH_SERVICE_TYPES } from "./types";

export const fetchServiceTypes = () => async (dispatch) => {
  const response = await agentApi.get("/api/services");

  dispatch({ type: FETCH_SERVICE_TYPES, payload: response.data });
};
